import { makeStyles, TextField } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import clsx from "clsx";
import { isAddress } from "ethers/lib/utils";
import { useState } from "react";

const useStyle = makeStyles(() => ({
  cleanIcon: {
    cursor: "pointer",
  },
  hideCleanIcon: {
    visibility: "hidden",
  },
}));

export default function AddressTextField({ address, events, ...props }) {
  const cls = useStyle();
  const [helperText, setHelperText] = useState(undefined);

  const onChange = (event) => {
    const value = event.target.value;
    if (!isAddress(value)) {
      setHelperText("Invalid wallet address");
    } else setHelperText(undefined);
    if (events?.onChange) events.onChange(value);
  };

  const onClearClick = () => {
    if (events?.onClear) events.onClear();
  };

  return (
    <TextField
      {...props}
      onChange={onChange}
      error={Boolean(helperText)}
      helperText={helperText}
      value={address}
      InputProps={{
        endAdornment: (
          <ClearIcon
            onClick={() => onClearClick()}
            className={clsx({
              [cls.cleanIcon]: address.length > 0,
              [cls.hideCleanIcon]: address.length === 0,
            })}
          />
        ),
      }}
    />
  );
}
